/* Channel Canna recipes: recipe-library finder, recipe-board tabs, menu builder.
   Plain JS, no dependencies. Every section is server-rendered and works
   without this file; this only adds filtering, tabs and the card builder.
   Loaded by each recipe section with `defer`; the guard keeps one copy. */
(function () {
  'use strict';
  if (window.__ccRecipes) return;
  window.__ccRecipes = true;

  var $$ = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var press = function (btns, on) { btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b === on)); }); };

  /* ---------------- Recipe library ---------------- */
  function initLibrary(root) {
    if (root.dataset.rcReady) return;
    root.dataset.rcReady = '1';
    var finder = root.querySelector('[data-rc-finder]');
    var bar = root.querySelector('[data-rc-statusbar]');
    var items = $$(root, '[data-rc-item]');
    var q = root.querySelector('[data-rc-q]');
    var occ = root.querySelector('[data-rc-occ]');
    var baseBtns = $$(root, '[data-rc-base]');
    var tempBtns = $$(root, '[data-rc-temp]');
    var count = root.querySelector('[data-rc-count]');
    var empty = root.querySelector('[data-rc-empty]');
    var clears = $$(root, '[data-rc-clear]');
    var state = { base: 'all', temp: 'all', occ: 'all', q: '' };

    // deep links: ?base=joe|tini &occasion=brunch &serve=frozen &q=
    try {
      var p = new URLSearchParams(location.search);
      if (/^(joe|tini)$/.test(p.get('base') || '')) state.base = p.get('base');
      if (/^(cold|frozen)$/.test(p.get('serve') || '')) state.temp = p.get('serve');
      if (p.get('occasion') && occ && occ.querySelector('option[value="' + p.get('occasion').replace(/[^a-z-]/g, '') + '"]')) state.occ = p.get('occasion');
      if (p.get('q')) state.q = p.get('q').slice(0, 60);
    } catch (e) { /* old browsers: no deep link */ }

    function apply() {
      var words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      items.forEach(function (it) {
        var ok = (state.base === 'all' || it.dataset.base === state.base) &&
          (state.temp === 'all' || it.dataset.temp === state.temp) &&
          (state.occ === 'all' || (it.dataset.occ || '').indexOf(' ' + state.occ + ' ') > -1) &&
          words.every(function (w) { return (it.dataset.text || '').indexOf(w) > -1; });
        it.hidden = !ok;
        if (ok) shown++;
      });
      var filtered = state.base !== 'all' || state.temp !== 'all' || state.occ !== 'all' || state.q !== '';
      count.textContent = shown === 1 ? '1 recipe' : shown + ' recipes';
      if (filtered) count.textContent += ' of ' + items.length;
      empty.hidden = shown !== 0;
      clears.forEach(function (c) { if (!empty.contains(c)) c.hidden = !filtered; });
    }
    function sync() {
      press(baseBtns, baseBtns.filter(function (b) { return b.dataset.rcBase === state.base; })[0]);
      press(tempBtns, tempBtns.filter(function (b) { return b.dataset.rcTemp === state.temp; })[0]);
      if (occ) occ.value = state.occ;
      if (q) q.value = state.q;
      apply();
    }
    baseBtns.forEach(function (b) { b.addEventListener('click', function () { state.base = b.dataset.rcBase; sync(); }); });
    tempBtns.forEach(function (b) { b.addEventListener('click', function () { state.temp = b.dataset.rcTemp; sync(); }); });
    if (occ) occ.addEventListener('change', function () { state.occ = occ.value; apply(); });
    if (q) q.addEventListener('input', function () { state.q = q.value.trim(); apply(); });
    clears.forEach(function (c) {
      c.addEventListener('click', function () { state = { base: 'all', temp: 'all', occ: 'all', q: '' }; sync(); if (q) q.focus(); });
    });

    function openHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !root.contains(el) || el.tagName !== 'DETAILS') return;
      if (el.hidden) { state = { base: 'all', temp: 'all', occ: 'all', q: '' }; sync(); }
      el.open = true;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      var s = el.querySelector('summary');
      if (s) s.focus({ preventScroll: true });
    }
    window.addEventListener('hashchange', openHash);

    finder.hidden = false;
    bar.hidden = false;
    sync();
    openHash();
  }

  /* ---------------- Recipe board (home teaser) ---------------- */
  function initBoard(root) {
    if (root.dataset.rcReady) return;
    root.dataset.rcReady = '1';
    var tabs = $$(root, '[data-rc-tab]');
    var cards = $$(root, '[data-rc-card]');
    var list = root.querySelector('[data-rc-cards]');
    var live = root.querySelector('[data-rc-count]');
    var all = root.querySelector('[data-rc-all]');
    var per = parseInt(root.dataset.perTab, 10) || 6;
    var featured = (root.dataset.featured || '').split(',').filter(Boolean);

    function show(tab) {
      var pick;
      if (tab === 'all') {
        pick = featured.length ? featured : cards.slice(0, per).map(function (c) { return c.dataset.handle; });
      } else {
        pick = cards.filter(function (c) { return c.dataset.base === tab; }).slice(0, per).map(function (c) { return c.dataset.handle; });
      }
      cards.forEach(function (c) { c.hidden = pick.indexOf(c.dataset.handle) === -1; });
      // featured order on the All tab
      pick.forEach(function (h) {
        var c = cards.filter(function (x) { return x.dataset.handle === h; })[0];
        if (c) list.appendChild(c);
      });
      if (live) live.textContent = pick.length + ' recipes shown';
      if (all && all.dataset.href) all.href = tab === 'all' ? all.dataset.href : all.dataset.href + '?base=' + tab;
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { press(tabs, b); show(b.dataset.rcTab); }); });
    var wrap = root.querySelector('[data-rc-tabs]');
    if (wrap) wrap.hidden = false;
    show('all');
  }

  /* ---------------- Menu builder ---------------- */
  function initBuilder(root) {
    if (root.dataset.rcReady) return;
    var dataEl = root.querySelector('[data-mb-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.rcReady = '1';
    var max = parseInt(root.dataset.max, 10) || 4;
    var fmtBtns = $$(root, '[data-mb-format]');
    var picksSet = root.querySelector('[data-mb-picks]');
    var boxes = $$(root, '[data-mb-pick]');
    var nameIn = root.querySelector('[data-mb-name]');
    var status = root.querySelector('[data-mb-status]');
    var card = root.querySelector('[data-mb-card]');
    var titleEl = root.querySelector('[data-mb-card-title]');
    var copyEl = root.querySelector('[data-mb-card-copy]');
    var itemsEl = root.querySelector('[data-mb-items]');
    var printBtn = root.querySelector('[data-mb-print]');
    var SHOW = 3; // drinks shown per coffee before "See more" (owner 2026-10-08)
    var groups = $$(root, '[data-mb-opts]').map(function (el) {
      return { el: el, opts: $$(el, '.mb-opt'), btn: el.nextElementSibling && el.nextElementSibling.matches('[data-mb-more]') ? el.nextElementSibling : null, open: false, keep: [] };
    });
    var over = false; // a 5th pick was tried: say why it didn't stick
    var WORDS = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];
    var byHandle = {};
    data.recipes.forEach(function (r) { byHandle[r.handle] = r; });
    var fmt = data.formats.filter(function (f) { return f.handle === root.dataset.default; })[0] || data.formats[0];
    var sel = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
    if (!sel.length) sel = fmt.picks.slice(0, max);

    function iconFor(h) {
      var box = boxes.filter(function (b) { return b.value === h; })[0];
      var svg = box && box.parentNode.querySelector('svg');
      if (!svg) return '';
      var c = svg.cloneNode(true);
      c.setAttribute('width', '52'); c.setAttribute('height', '52');
      return c.outerHTML;
    }
    function cardWhere() { return window.matchMedia && matchMedia('(min-width: 1000px)').matches ? 'on the right' : 'below'; }
    function statusText() {
      var n = sel.length;
      if (over && n >= max) return (WORDS[max] || max) + ' is the max. Uncheck one to swap it in.';
      if (!n) return 'Pick up to ' + max + ' drinks for your menu.';
      if (n < max) return n + ' picked. Add up to ' + max + '. Your menu card updates ' + cardWhere() + '.';
      return 'Your menu is ready ' + cardWhere() + '. Text it to a friend or print it out.';
    }
    /* Short pick list: the first SHOW drinks of each coffee, plus any checked
       drink (and any just unchecked, so it doesn't vanish under the finger). */
    function fold() {
      groups.forEach(function (g) {
        var hidden = 0;
        g.opts.forEach(function (o, i) {
          var box = o.querySelector('[data-mb-pick]');
          var v = box ? box.value : '';
          var hide = !g.open && i >= SHOW && sel.indexOf(v) === -1 && g.keep.indexOf(v) === -1;
          o.hidden = hide;
          if (hide) hidden++;
        });
        if (!g.btn) return;
        g.btn.hidden = g.opts.length <= SHOW;
        g.btn.setAttribute('aria-expanded', String(g.open));
        g.btn.textContent = g.open ? 'Show fewer' : (hidden ? 'See more (' + hidden + ')' : 'See all');
      });
    }
    function draw() {
      boxes.forEach(function (b) { b.checked = sel.indexOf(b.value) > -1; });
      picksSet.classList.toggle('is-full', sel.length >= max);
      fold();
      var custom = nameIn && nameIn.value.trim();
      titleEl.textContent = custom || fmt.title;
      copyEl.textContent = fmt.copy;
      if (nameIn) nameIn.placeholder = fmt.title;
      itemsEl.innerHTML = sel.length ? sel.map(function (h) {
        var r = byHandle[h];
        if (!r) return '';
        return '<li class="mb-card__item" data-handle="' + esc(h) + '">' + iconFor(h) +
          '<div><strong>' + esc(r.name) + '</strong><span>' + esc(r.line) + '</span></div></li>';
      }).join('') : '<li class="mb-card__empty">Pick up to ' + max + ' drinks.</li>';
      status.textContent = statusText();
      if (printBtn) printBtn.disabled = !sel.length;
    }
    fmtBtns.forEach(function (b) {
      b.disabled = false;
      b.addEventListener('click', function () {
        fmt = data.formats.filter(function (f) { return f.handle === b.dataset.mbFormat; })[0] || fmt;
        sel = fmt.picks.slice(0, max);
        over = false;
        groups.forEach(function (g) { g.keep = []; });
        press(fmtBtns, b);
        draw();
      });
    });
    picksSet.disabled = false;
    picksSet.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches('[data-mb-pick]')) return;
      over = false;
      if (t.checked && sel.indexOf(t.value) === -1) {
        if (sel.length < max) sel.push(t.value);
        else over = true; // draw() unchecks it again
      }
      if (!t.checked) {
        sel = sel.filter(function (h) { return h !== t.value; });
        groups.forEach(function (g) { if (g.el.contains(t) && g.keep.indexOf(t.value) === -1) g.keep.push(t.value); });
      }
      draw();
    });
    groups.forEach(function (g) {
      if (!g.btn) return;
      g.btn.addEventListener('click', function () {
        g.open = !g.open;
        g.keep = [];
        fold(); // focus stays on the button; aria-expanded announces the change

      });
    });
    if (nameIn) {
      nameIn.disabled = false;
      nameIn.addEventListener('input', draw);
    }

    /* Phones (owner 2026-10-08): "Save or share as PDF". The card is drawn
       to a real PDF (html2canvas + jsPDF, loaded only on tap) and handed to
       the share sheet so it can be texted or AirDropped; where sharing files
       isn't possible it downloads. If the browser says the tap has expired
       while the PDF was being made, the button turns into "Tap to share". */
    var ready = null;
    function phone() { return window.matchMedia && matchMedia('(max-width: 767px), (pointer: coarse)').matches; }
    function lib(src, test) {
      return new Promise(function (res, rej) {
        if (test()) return res();
        var s = document.createElement('script'); s.src = src; s.async = true;
        s.onload = function () { test() ? res() : rej(new Error('load')); }; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    /* The PDF is drawn directly with jsPDF from the card's text (no page
       screenshot): it takes a few milliseconds, so the tap can open the share
       sheet straight away on every phone browser. */
    var JSPDF = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    var wm = { data: null, w: 0, h: 0, job: null };
    function loadWordmark() {
      if (wm.data || wm.job) return wm.job || Promise.resolve();
      var el = card.querySelector('.mb-card__wm');
      var src = el ? (el.currentSrc || el.src) : '';
      wm.job = new Promise(function (res) {
        if (!src) return res();
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
            c.getContext('2d').drawImage(im, 0, 0); wm.data = c.toDataURL('image/png'); wm.w = c.width; wm.h = c.height; wm.img = im;
          } catch (err) {}
          res();
        };
        im.onerror = function () { res(); };
        setTimeout(res, 4000);
        im.src = src;
      });
      return wm.job;
    }
    /* The card's art (drink icons, corner ornaments) is turned into images
       ahead of time; the card is then painted onto a canvas with the site's
       own fonts. Painting takes milliseconds, so the tap still shares at once
       and the PDF looks like the desktop print. */
    var art = { icons: {}, orn: null, job: null };
    function svgImage(svg, color) {
      return new Promise(function (res) {
        try {
          var c = svg.cloneNode(true);
          c.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          var vb = (c.getAttribute('viewBox') || '0 0 256 256').split(/[\s,]+/);
          c.setAttribute('width', vb[2] * 2); c.setAttribute('height', vb[3] * 2);
          c.removeAttribute('class');
          var s = new XMLSerializer().serializeToString(c).replace(/currentColor/g, color);
          var im = new Image();
          im.onload = function () { res(im); }; im.onerror = function () { res(null); };
          im.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
        } catch (err) { res(null); }
      });
    }
    function loadArt() {
      if (art.job) return art.job;
      var jobs = [];
      var inkColor = getComputedStyle(card).color || '#3B1200';
      Array.prototype.slice.call(root.querySelectorAll('.mb-opt')).forEach(function (o) {
        var inp = o.querySelector('input'), svg = o.querySelector('svg');
        if (!inp || !svg || art.icons[inp.value]) return;
        jobs.push(svgImage(svg, inkColor).then(function (im) { if (im) art.icons[inp.value] = im; }));
      });
      var orn = card.querySelector('.mb-card__orn');
      if (orn) jobs.push(svgImage(orn, getComputedStyle(orn).color || inkColor).then(function (im) { art.orn = im; }));
      art.job = Promise.all(jobs).then(function () { return document.fonts && document.fonts.ready; }).then(function () { art.done = true; });
      return art.job;
    }
    var LIBS = function () {
      return Promise.all([
        lib(JSPDF, function () { return !!(window.jspdf && window.jspdf.jsPDF); }),
        loadWordmark(), loadArt()
      ]);
    };
    function pdfReady() { return !!(window.jspdf && window.jspdf.jsPDF) && !!art.done; }
    function txt(sel) { var el = card.querySelector(sel); return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function cs(el) { return el ? getComputedStyle(el) : null; }
    function paintCard() {
      var CW = 540, P = 40, S = 2, IW = CW - 2 * P;
      var c = document.createElement('canvas'), x = c.getContext('2d');
      function font(el, size, weight) {
        var st = cs(el); var fam = st ? st.fontFamily : 'sans-serif';
        return (weight || (st ? st.fontWeight : '400')) + ' ' + size + 'px ' + fam;
      }
      function wrap(text, maxW) {
        var words = String(text || '').split(/\s+/), out = [], line = '';
        words.forEach(function (w) { var tst = line ? line + ' ' + w : w; if (x.measureText(tst).width > maxW && line) { out.push(line); line = w; } else line = tst; });
        if (line) out.push(line); return out;
      }
      function spaced(on) { try { x.letterSpacing = on || '0px'; } catch (err) {} }
      var titleEl = card.querySelector('.mb-card__title'), copyEl = card.querySelector('.mb-card__copy'),
          kickEl = card.querySelector('.mb-card__kicker'), legalEl = card.querySelector('.mb-card__legal'),
          availEl = card.querySelector('.mb-card__avail'), ruleEl = card.querySelector('.mb-card__rule');
      var nameEl = card.querySelector('.mb-card__item strong'), descEl = card.querySelector('.mb-card__item span');
      var fB = card.querySelector('.mb-card__formula b'), fS = card.querySelector('.mb-card__formula small');
      var roast = cs(titleEl) ? cs(titleEl).color : '#3B1200', mocha = cs(copyEl) ? cs(copyEl).color : '#4E3222';
      var items = Array.prototype.slice.call(card.querySelectorAll('.mb-card__item')).map(function (li) {
        var s = li.querySelector('strong'), d = li.querySelector('span');
        return { h: li.getAttribute('data-handle'), n: s ? s.textContent.trim() : '', d: d ? d.textContent.trim() : '' };
      });
      function layout(draw) {
        var y = P + 6;
        if (draw && art.orn) {
          x.drawImage(art.orn, 22, 22, 64, 64);
          x.save(); x.translate(CW - 22, 22); x.scale(-1, 1); x.drawImage(art.orn, 0, 0, 64, 64); x.restore();
        }
        if (wm.data && wm.img) { var ww = 180, wh = ww * wm.h / wm.w; if (draw) x.drawImage(wm.img, (CW - ww) / 2, y, ww, wh); y += wh + 14; }
        x.textAlign = 'center'; x.textBaseline = 'alphabetic';
        x.font = font(kickEl, 14); spaced('2px'); x.fillStyle = cs(kickEl) ? cs(kickEl).color : mocha;
        y += 14; if (draw) x.fillText(txt('.mb-card__kicker').toUpperCase(), CW / 2, y); spaced(); y += 18;
        x.font = font(titleEl, 52); x.fillStyle = roast;
        wrap(txt('.mb-card__title').toUpperCase(), IW).forEach(function (l) { y += 48; if (draw) x.fillText(l, CW / 2, y); });
        y += 18; x.font = font(copyEl, 16); x.fillStyle = mocha;
        wrap(txt('.mb-card__copy'), IW - 20).forEach(function (l) { y += 22; if (draw) x.fillText(l, CW / 2, y); });
        y += 22; x.textAlign = 'left';
        items.forEach(function (it) {
          var top = y, tx = P + 66;
          x.font = font(nameEl, 21); x.fillStyle = roast; spaced('1px');
          var nl = wrap(it.n.toUpperCase(), IW - 66); spaced();
          x.font = font(descEl, 15); var dl = wrap(it.d, IW - 66);
          var bh = nl.length * 24 + dl.length * 20 + 4, ih = Math.max(56, bh);
          if (draw) {
            var icon = art.icons[it.h]; if (icon) x.drawImage(icon, P, top + (ih - 56) / 2, 56, 56);
            var yy = top + (ih - bh) / 2;
            x.font = font(nameEl, 21); x.fillStyle = roast; spaced('1px');
            nl.forEach(function (l) { yy += 22; x.fillText(l, tx, yy); }); spaced(); yy += 2;
            x.font = font(descEl, 15); x.fillStyle = mocha;
            dl.forEach(function (l) { yy += 20; x.fillText(l, tx, yy); });
          }
          y += ih + 16;
        });
        var bw = (IW - 12) / 2, bh2 = 62;
        y += 4;
        if (draw) {
          x.strokeStyle = cs(card.querySelector('.mb-card__formula')) ? cs(card.querySelector('.mb-card__formula')).borderTopColor : roast;
          x.lineWidth = 2.5;
          [0, 1].forEach(function (i) {
            var bx = P + i * (bw + 12);
            x.beginPath(); if (x.roundRect) x.roundRect(bx, y, bw, bh2, 16); else x.rect(bx, y, bw, bh2); x.stroke();
            x.textAlign = 'center'; x.fillStyle = cs(fB) ? cs(fB).color : roast;
            x.font = font(fB, 16, '800'); spaced('0.6px');
            x.fillText(i ? 'CBD-FORWARD' : 'INFUSED', bx + bw / 2, y + (i && fS ? 28 : 37)); spaced();
            if (i && fS) { x.font = font(fS, 14, '500'); x.fillStyle = mocha; x.fillText(fS.textContent.trim(), bx + bw / 2, y + 48); }
          });
        }
        y += bh2 + 10; x.textAlign = 'center';
        x.font = font(availEl, 15, '600'); x.fillStyle = mocha;
        wrap(txt('.mb-card__avail'), IW).forEach(function (l) { y += 21; if (draw) x.fillText(l, CW / 2, y); });
        x.font = font(ruleEl, 14);
        wrap(txt('.mb-card__rule'), IW).forEach(function (l) { y += 20; if (draw) x.fillText(l, CW / 2, y); });
        y += 14; if (draw) { x.fillStyle = roast; x.fillRect(P, y, IW, 2); } y += 10;
        x.font = font(legalEl, 13, '700'); x.fillStyle = roast; spaced('0.8px');
        wrap(txt('.mb-card__legal').toUpperCase(), IW).forEach(function (l) { y += 18; if (draw) x.fillText(l, CW / 2, y); }); spaced();
        return y + P;
      }
      x.save(); var H = Math.ceil(layout(false)); x.restore();
      c.width = CW * S; c.height = H * S; x = c.getContext('2d'); x.scale(S, S);
      x.fillStyle = cs(card) ? cs(card).backgroundColor : '#E7DBC7';
      if (!x.fillStyle || /rgba\(0, 0, 0, 0\)/.test(cs(card).backgroundColor)) x.fillStyle = '#E7DBC7';
      x.fillRect(0, 0, CW, H);
      x.strokeStyle = roast; x.lineWidth = 3;
      x.beginPath(); if (x.roundRect) x.roundRect(8, 8, CW - 16, H - 16, 26); else x.rect(8, 8, CW - 16, H - 16); x.stroke();
      layout(true);
      return c;
    }
    function buildPdf() {
      var J = window.jspdf.jsPDF;
      var canvas = paintCard();
      var w = 5.5, h = w * canvas.height / canvas.width;
      var doc = new J({ unit: 'in', format: [w, h], orientation: h >= w ? 'portrait' : 'landscape' });
      doc.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, w, h);
      var name = (txt('.mb-card__title') || 'Canna Coffee menu').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'canna-coffee-menu';
      var blob = doc.output('blob');
      try { return new File([blob], name + '.pdf', { type: 'application/pdf' }); }
      catch (err) { blob.name = name + '.pdf'; return blob; }
    }
    function makePdf() { return LIBS().then(buildPdf); }
    /* warm the PDF tools when the builder comes into view on phones */
    if ('IntersectionObserver' in window && phone()) {
      var warm = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { warm.disconnect(); LIBS().catch(function () {}); } }, { rootMargin: '400px 0px' });
      warm.observe(root);
    }
    function deliver(file) {
      var data = { files: [file], title: (titleEl && titleEl.textContent || 'Our menu').trim(), text: 'Canna Coffee drinks on our menu. cannacoffee.co' };
      var canFiles = false;
      try { canFiles = !!(navigator.share && window.File && file instanceof File && (!navigator.canShare || navigator.canShare({ files: [file] }))); } catch (e) {}
      if (canFiles) {
        return navigator.share(data).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (err && err.name === 'NotAllowedError') { printBtn.classList.add('is-ready'); label('Tap to share'); return; }
          openPdf(file);
        });
      }
      openPdf(file);
      return Promise.resolve();
    }
    /* Browsers that can't share files (some in-app and iOS Chrome builds): a
       download link does nothing on iPhone, so open the PDF itself; the
       phone's own Share button takes it from there. */
    function openPdf(file) {
      var url = URL.createObjectURL(file);
      var ios = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!ios) {
        var a = document.createElement('a'); a.href = url; a.download = file.name || 'canna-coffee-menu.pdf';
        document.body.appendChild(a); a.click(); setTimeout(function () { a.remove(); }, 4000);
      } else {
        var w = window.open(url, '_blank');
        if (!w) window.location.href = url;
      }
      setTimeout(function () { URL.revokeObjectURL(url); }, 120000);
    }
    function download(file) { openPdf(file); }
    /* iPhone only opens the share sheet straight from a tap, so the PDF is
       built ahead of time (when the builder is on screen and after every
       change) and the tap hands over a finished file. If it isn't ready yet,
       the tap starts it and the button turns into "Tap to share". */
    var cache = { key: '', file: null, job: null };
    function cardKey() { return (titleEl ? titleEl.textContent : '') + '|' + card.textContent.length + '|' + card.querySelectorAll('li, [data-handle]').length + '|' + (card.textContent.slice(0, 400)); }
    function label(txt) { var s = printBtn.querySelector('.mb-print__phone'); if (s) s.textContent = txt; }
    function idle() { printBtn.classList.remove('is-busy', 'is-ready'); printBtn.removeAttribute('aria-busy'); label(printBtn.getAttribute('data-share-label')); }
    function prepare() {
      var key = cardKey();
      if (cache.key === key && (cache.file || cache.job)) return cache.job || Promise.resolve(cache.file);
      cache.key = key; cache.file = null;
      var job = makePdf().then(function (file) {
        if (cache.key === key) { cache.file = file; cache.job = null; }
        return file;
      }, function (err) { if (cache.job === job) cache.job = null; throw err; });
      cache.job = job;
      return job;
    }
    var prepTimer = 0;
    function prepSoon() {
      if (!phone()) return;
      clearTimeout(prepTimer);
      prepTimer = setTimeout(function () { LIBS().catch(function () {}); }, 300);
    }
    root.addEventListener('change', prepSoon);
    root.addEventListener('input', prepSoon);
    root.addEventListener('click', function (e) { if (!e.target.closest('[data-mb-print]')) prepSoon(); });
    if ('IntersectionObserver' in window && phone()) {
      var seenIO = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { seenIO.disconnect(); prepSoon(); } }, { rootMargin: '300px 0px' });
      seenIO.observe(root);
    }
    function sharePdf() {
      if (!phone()) return false;
      if (pdfReady()) {
        var f = null; try { f = buildPdf(); } catch (err) { f = null; }
        if (f) { idle(); deliver(f); return true; }
      }
      if (printBtn.classList.contains('is-busy')) return true;
      printBtn.classList.add('is-busy'); printBtn.setAttribute('aria-busy', 'true'); label('Preparing your PDF');
      var done = false;
      var guard = setTimeout(function () { if (done) return; done = true; idle(); window.print(); }, 10000);
      LIBS().then(function () {
        if (done) return; done = true; clearTimeout(guard);
        printBtn.classList.remove('is-busy'); printBtn.removeAttribute('aria-busy');
        printBtn.classList.add('is-ready'); label('Tap to share');
      }, function () { if (done) return; done = true; clearTimeout(guard); idle(); window.print(); });
      return true;
    }
    if (printBtn) printBtn.setAttribute('data-share-label', (printBtn.querySelector('.mb-print__phone') || {}).textContent || 'Save or share as PDF');

    /* Print or save: clone the card into a body-level root so the print CSS
       can hide everything else (header, footer, age gate) for one page. */
    function cleanup() {
      document.documentElement.classList.remove('mb-printing');
      var old = document.querySelector('.mb-print-root');
      if (old) old.parentNode.removeChild(old);
    }
    if (printBtn) {
      printBtn.hidden = false;
      printBtn.addEventListener('click', function (e) {
        if (sharePdf(e)) return;
        cleanup();
        var holder = document.createElement('div');
        holder.className = 'mb mb-print-root';
        var clone = card.cloneNode(true);
        $$(clone, 'img[loading]').forEach(function (img) { img.loading = 'eager'; });
        holder.appendChild(clone);
        document.body.appendChild(holder);
        document.documentElement.classList.add('mb-printing');
        var imgs = $$(holder, 'img');
        var go = function () { window.print(); };
        Promise.all(imgs.map(function (img) {
          return img.complete ? Promise.resolve() : new Promise(function (res) { img.onload = img.onerror = res; setTimeout(res, 1500); });
        })).then(go);
      });
      window.addEventListener('afterprint', cleanup);
    }
    draw();
  }

  function init(scope) {
    var r = scope || document;
    $$(r, '[data-rc-lib]').forEach(initLibrary);
    $$(r, '[data-rc-board]').forEach(initBoard);
    $$(r, '[data-mb]').forEach(initBuilder);
    if (r.matches && r.matches('[data-rc-lib]')) initLibrary(r);
    if (r.matches && r.matches('[data-rc-board]')) initBoard(r);
    if (r.matches && r.matches('[data-mb]')) initBuilder(r);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
